import React, { useState } from 'react';
import { Star, StarHalf } from 'lucide-react';

interface StarRatingProps {
  rating: number;
  onRatingChange: (rating: number) => void;
  label: string;
}

const StarRating: React.FC<StarRatingProps> = ({ rating, onRatingChange, label }) => {
  const [hoverRating, setHoverRating] = useState<number | null>(null);
  
  const handleMouseMove = (e: React.MouseEvent<HTMLDivElement>, starIndex: number) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const width = rect.width;
    const x = e.clientX - rect.left;
    const halfWidth = width / 2;
    
    if (x < halfWidth) {
      setHoverRating(starIndex + 0.5);
    } else {
      setHoverRating(starIndex + 1);
    }
  };

  const handleClick = (starIndex: number, e: React.MouseEvent<HTMLDivElement>) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const width = rect.width;
    const x = e.clientX - rect.left;
    const halfWidth = width / 2;
    
    if (x < halfWidth) {
      onRatingChange(starIndex + 0.5);
    } else {
      onRatingChange(starIndex + 1);
    }
  };

  const renderStar = (index: number) => {
    const currentRating = hoverRating !== null ? hoverRating : rating;
    const filled = currentRating - index;
    
    return (
      <div
        key={index}
        className="cursor-pointer inline-block"
        onMouseMove={(e) => handleMouseMove(e, index)}
        onClick={(e) => handleClick(index, e)}
      >
        {filled >= 1 ? (
          <Star className="w-5 h-5 text-yellow-400 fill-yellow-400" />
        ) : filled > 0 ? (
          <StarHalf className="w-5 h-5 text-yellow-400 fill-yellow-400" />
        ) : (
          <Star className="w-5 h-5 text-gray-300" />
        )}
      </div>
    );
  };

  return (
    <div className="space-y-2"
         onMouseLeave={() => setHoverRating(null)}>
      <label className="block text-sm font-medium text-gray-700">{label}</label>
      <div className="flex gap-1">
        {[0, 1, 2, 3, 4].map(index => renderStar(index))}
      </div>
    </div>
  );
};

export default StarRating;